import { render } from "./DescriptionHistory.vue?vue&type=template&id=2ac698bd"
import script from "./DescriptionHistory.vue?vue&type=script&lang=js"
export * from "./DescriptionHistory.vue?vue&type=script&lang=js"

import "./DescriptionHistory.vue?vue&type=style&index=0&id=2ac698bd&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__